import $ from 'jquery';
let oldBodyPosition = 0;
/**
 * @description Freeze body scrolling when offcanvas drawers are open
 */ export const freeze = function(additionalClass = '') {
    const body = $('body');
    const offset = ($(window).scrollTop() || 0) * -1;
    oldBodyPosition = parseInt(body.css('top'), 10) || 0;
    body.css('top', offset).addClass([
        'is-frozen',
        additionalClass
    ].join(' '));
};
/**
 * @description Unfreeze body scrolling after offcanvas drawers are closed
 */ export const thaw = function(additionalClass = '') {
    const body = $('body');
    body.css('top', '').removeClass([
        'is-frozen',
        additionalClass
    ].join(' '));
    if (oldBodyPosition) {
        window.requestAnimationFrame(function() {
            return $(window).scrollTop(oldBodyPosition * -1);
        });
    }
};
